import { PaymentTypes, PricingTypes } from "shared-types/index";
import UtilsService from "app/services/utils/utils.service";
import BookingOptionsManagerService from "app/services/bookingOptionsManager/bookingOptionsManager.service";
import TagsService from "external-services/tags-service";
import AdminService from "external-services/diary-admin-service/admin.service";

const NS = 'MenuOptionsAutocomplete';

// requiring html templates so that hot reloading works
const template = require('./menuOptionsAutocomplete.html');

export default function MenuOptionsAutocomplete() {
    return {
        restrict: 'E',
        replace: true,
        controllerAs: 'vm',
        template,
        scope: {
            items: '=',
            samePaymentType: '@',
            neutralPaymentType: '@',
            minlng: '=',
            maxlng: '@',
            isUpsell: '@',
            paymentType: '@',
            secondItems: '='
        },
        require: 'ngModel',
        link,
        controller
    };
}

function controller($scope, appConstants, hardCodedTags, unregister) {
    "ngInject";

    var vm = this;

    const listeners = [];

    vm.searchText = null;
    vm.allItems = [];
    vm.currency = AdminService.getVenue()?.currency;
    vm.add = add;
    vm.removed = removed;
    vm.search = search;

    listeners.push($scope.$on('$destroy', () => unregister(listeners)));

    //-- init
    var isTakeAwayMode = AdminService.getVenue().isTakeAwayMode;

    $scope.items = $scope.items || [];

    if (isTakeAwayMode) {
        var paymentTypes = appConstants.Payment.PaymentTypes;
        $scope.items.forEach(o => {
            o.isIncompatiblePaymentType = o.paymentType !== paymentTypes.FullPayment && o.paymentType !== paymentTypes.NoPayment;
        });
    }

    getAllMenuOpions();

    function getAllMenuOpions() {
      BookingOptionsManagerService.getAll().then(function(allItems) {
            /**
             * Removes archived items from the list.
             * Only allow 'standalone' menu options to be selected.
             * If 'isStandaloneItem' is not yet set we assume they are standalone, as they would have been created before
             * this property was introduced.
             */
            vm.allItems = allItems.filter(o => !o.isArchived && (typeof o.isStandaloneItem === 'undefined' || o.isStandaloneItem === true));

            pushDeliveryOptionsToTop();
        });
    }


    function pushDeliveryOptionsToTop() {
        vm.allItems.forEach(opt => {

            if (opt.tag === hardCodedTags.DELIVERY_TAG_ID) {
                const index = vm.allItems.indexOf(opt);
                const deliveryOpt = vm.allItems.splice(index, 1)[0];
                if (deliveryOpt) {
                    deliveryOpt.isSpecialColor = true;
                    vm.allItems.unshift(deliveryOpt);
                }
            } else if (opt.tag) {
                /**
                 * @todo remove the below 'check by name' once all early 'delivery-fee' venues have removed their
                 * manually created tags and started using the 'by id' delivery tag.
                 */
                TagsService.getTagById(opt.tag)
                    .then(tag => {
                        if (tag.name === hardCodedTags.DELIVERY_TAG_NAME) {
                            const index = vm.allItems.indexOf(opt);
                            const deliveryOpt = vm.allItems.splice(index, 1)[0];
                            if (deliveryOpt) {
                                deliveryOpt.isSpecialColor = true;
                                vm.allItems.unshift(deliveryOpt);
                            }
                        }
                    });
            }
        });
    }

    function search(query) {
        // Normalize query input
        var q = query ? query.toLowerCase().trim() : null;


        // Filter items against query
        var results = q ? vm.allItems.filter(function(item) {
            return item.name.toLowerCase().indexOf(q) > -1;
        }) : vm.allItems;

        // Allow only items not already selected
        results = results.filter(function(i) {
            return $scope.items.find(function(i2) {
                return i._id === i2._id;
            }) == null;
        });

        // Allow only the options which has not been selected in either normal BO or Upsell Options
        if ($scope.secondItems && $scope.secondItems.length > 0) {
            results = results.filter((option) => {
                return !$scope.secondItems.some(val => val._id === option._id);
            });
        }

        // Not trigger this filter for MenuOptions and FunctionPayment
        if (
            $scope.samePaymentType &&
            $scope.paymentType !== $scope.neutralPaymentType &&
            $scope.paymentType !== PaymentTypes.MenuOptions &&
            $scope.paymentType !== PaymentTypes.FunctionPayment
        ) {
            results = results.filter(function(opt) {
                return ($scope.neutralPaymentType && opt.paymentType === $scope.neutralPaymentType) ||
                    (opt.paymentType === $scope.paymentType);
            });
        }

        // Only allow full payments and no payments when in takeaway mode
        if (isTakeAwayMode) {
            results = results.filter(function(opt) {
                return opt.paymentType === appConstants.Payment.PaymentTypes.FullPayment ||
                    opt.paymentType === appConstants.Payment.PaymentTypes.NoPayment;
            });
        }

        // Filtered items
        return results;
    }

    /**
     * Add an item to the list
     * @param {Object} item
     */
    function add(item) {
        if (item) {
            var index = $scope.items.map(function(e) {
                return e._id;
            }).indexOf(item._id);
            // make sure the item is not already in the array
            if (index === -1) {
                if ($scope.maxlng) {
                    while (parseInt($scope.maxlng) <= $scope.items.length) {
                        $scope.items.pop();
                    }
                }
                $scope.items.push(item);
                $scope.$emit('menuoptions-updated');
                vm.searchText = '';
            }
        }
    }

    /**
     * Remove the item from the list
     * @param {Object} item
     */
    function removed() {
        $scope.$emit('menuoptions-updated');
        UtilsService.autoCompleteRefreshHack(vm);
    }
}

function link(scope, elm, attrs, ctrl) {
    ctrl.$validators.minlng = function(modelValue) {
        if (attrs.minlng && !isNaN(attrs.minlng)) {
            return modelValue && modelValue.length >= parseInt(attrs.minlng);
        }
        return true;
    };

    ctrl.$validators.maxlng = function(modelValue) {
        if (attrs.maxlng && !isNaN(attrs.maxlng)) {
            return modelValue && modelValue.length <= parseInt(attrs.maxlng);
        }
        return true;
    };
}
